/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {useQuery} from 'react-query'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {resolveChartColor, withPremiumTheme} from './chart-theme'
import {Graphic3Type} from '../core/_models'
import {getGraphic3} from '../core/_requests'
import {useAuth} from '../../../../app/modules/auth'
import {useMenuInnerContext} from "../../../../_metronic/layout/components/header/header-menus/MenuInnerContext"

type Props = {
  className: string
  chartColor: string
  chartHeight: string
}

const Graphic3: React.FC<Props> = ({ className, chartColor, chartHeight }) => {
  const {currentUser} = useAuth()
  const chartRef = useRef<HTMLDivElement | null>(null)
  const [refreshGraphic, setRefreshGraphic] = useState(false)

  const menuInnerContext = useMenuInnerContext()

  const query = useQuery(
    'total_erros-bux_number',
    () => getGraphic3(currentUser!.last_company_id, menuInnerContext.dashboardStartDate, menuInnerContext.dashboardEndDate), {
    cacheTime: 0,
    refetchOnWindowFocus: false,
  })

  const refreshChart = () => {
    if (!chartRef.current || query.isFetching) {
      return
    }

    const chart1 = new ApexCharts(chartRef.current, chart1Options(chartColor, chartHeight, query.data))
    if (chart1) {
      chart1.render()
    }

    setRefreshGraphic(false)
    return chart1
  }

  useEffect(() => {
    query.refetch().then(() => {
      setRefreshGraphic(true)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, menuInnerContext.dashboardStartDate, menuInnerContext.dashboardEndDate])

  useEffect(() => {
    menuInnerContext.addFetchingGraphic('graphic3', query.isFetching)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isFetching])

  useEffect(() => {
    const chart1 = refreshChart()

    return () => {
      if (chart1) {
        chart1.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, query.data, refreshGraphic])

  return (
    <div className={className}>
      {(query.data && query.data.length > 0) ? (
        <div ref={chartRef} ></div>
      ) : (
        <div className='d-flex flex-1 justify-content-center align-items-center fs-7' style={{ color: '#9ca3af', minHeight: 180 }}>
          {query.isFetching ? (
            <div className="spinner-border text-secondary spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : 'Sem dados'}
        </div>
      )}
    </div>
  )
}

const chart1Options = (chartColor: string, chartHeight: string, data: Graphic3Type[] | undefined): ApexOptions => {
  const baseColor = resolveChartColor(chartColor);
  return withPremiumTheme({
    series: [{
      name: 'Total de erros de abertura',
      data: data ? data.map((box) => box.total_errors) : []
    }],
    chart: { type: 'bar', height: chartHeight },
    plotOptions: { bar: { horizontal: false, columnWidth: '60', borderRadius: 4 } },
    legend: { show: false },
    stroke: { show: false },
    xaxis: {
      categories: data ? data.sort((a, b) => b.total_errors - a.total_errors).map((box) => box.box_number) : [],
    },
    fill: { opacity: 0.95 },
    tooltip: {
      x: { formatter: (val) => 'Caixa nº: ' + val },
      y: { formatter: (val) => val.toString() },
    },
    colors: [baseColor],
  });
}

export { Graphic3 }
